module.exports = __webpack_public_path__ + "static/media/green_dot.1f132330.svg";